import React from 'react'
import { useTranslation } from 'react-i18next'

import { IMAGE_SIZES } from '@hozana/styling/image'
import { QA } from '@hozana/tests/constants'

import { RoundDiv, TRoundDivProps } from 'elements/layout/RoundDiv'
import { Image, TImageProps } from 'elements/media/Image'

import { DEFAULT_AVATAR_IMG } from 'modules/user/constants'
import type { TAvatar } from 'modules/user/types'

export type TAvatarImageProps = Omit<TRoundDivProps, 'size'> & {
  size?: keyof typeof IMAGE_SIZES.avatar
  avatar?: Partial<TAvatar>
  username?: string
} & Partial<Pick<TImageProps, 'alt'>>

export const AvatarImage: TFCC<TAvatarImageProps> = ({
  size = 'tiny',
  avatar,
  username,
  alt = 'user:words.avatar',
  ...otherProps
}) => {
  const { t } = useTranslation()
  const imageSize = IMAGE_SIZES.avatar[size]
  const side = imageSize.replace(/x\d+/, 'px')

  return (
    <RoundDiv
      w={side}
      h={side}
      m="auto"
      noOverflow
      borderColor="black10"
      bg="white"
      data-testid={QA.USER_COMMON.AVATAR}
      {...otherProps}
    >
      <Image
        data-testid={QA.COMMON.AVATAR_IMAGE}
        src={avatar?.icon?.id || DEFAULT_AVATAR_IMG}
        size={imageSize}
        alt={username ? t('common:user.avatar.image-alt', { name: username }) : alt}
      />
    </RoundDiv>
  )
}
